var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductDetails',{attrs:{"product":_vm.product,"is-fetching":_vm.isFetching},scopedSlots:_vm._u([{key:"options",fn:function(ref){
var canAddToCart = ref.canAddToCart;
var showAddToCart = ref.showAddToCart;
return [_c('grouped-product-selector',{attrs:{"can-add-to-cart":canAddToCart(_vm.product, _vm.qty),"show-add-to-cart":showAddToCart,"product":_vm.product},on:{"update-price":function($event){_vm.basePrice = $event}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }